import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Box,
  Typography, 
  TextField, 
  Button, 
  Paper, 
  Grid, 
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  IconButton,
  Tooltip
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close'; // Import CloseIcon
import { useNavigate } from 'react-router-dom';
import { TourOutlined } from '@mui/icons-material';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const SimpleTaxFormCreation = () => {

    const navigate =useNavigate();
  // State for form inputs
  const [employeeId, setEmployeeId] = useState('');
  const [employeeData, setEmployeeData] = useState(null);
  const [financialYearFrom, setFinancialYearFrom] = useState(null);
  const [financialYearTo, setFinancialYearTo] = useState(null);
  const [assessmentYear, setAssessmentYear] = useState('');
  const [employerPan, setEmployerPan] = useState('');
  const [employerName, setEmployerName] = useState('');
  const [employerAddress, setEmployerAddress] = useState('');
  const [cit, setcit] = useState('');
    const [employerPanError, setEmployerPanError] = useState(false);

  
  // UI states
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(true); // Set to true initially
  const [notification, setNotification] = useState({ open: false, message: '', type: 'info' });
const [validationErrors, setValidationErrors] = useState({
  employeeId: false,
  financialYearFrom: false,
  financialYearTo: false,
  assessmentYear: false,
  employerName: false,
  employerAddress: false,
  employerPan: false,
  cit: false
});
  // Use effect to open dialog when component mounts
  useEffect(() => {
    setDialogOpen(true);
  }, []);

  // Open the employee search dialog
  const openEmployeeDialog = () => {
    setDialogOpen(true);
  };

  // Close the employee search dialog
  const closeEmployeeDialog = () => {
    setDialogOpen(false);
  };

  // Fetch employee details when search button is clicked in dialog
  const fetchEmployeeDetails = async () => {
    if (!employeeId) return;
    
    setLoading(true);
    try {
      const token = localStorage.getItem('token'); 
        if (!token) {
          alert("No authentication token found. Please log in.");
          return;
        }
        const payload = JSON.parse(atob(token.split('.')[1]));
        const company_id = payload.company_id;
      const response = await axios.get(`${API_URL}/api/form16A/employee/${employeeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            
          }
        }
      );
      setEmployeeData(response.data.data);
    //   setEmployerPan(response.data.data.company.tan || '');
      closeEmployeeDialog();
      setNotification({
        open: true,
        message: 'Employee details loaded successfully',
        type: 'success'
      });
    } catch (error) {
      //console.error('Error fetching employee details:', error);
      setNotification({
        open: true,
        message: error.response?.data?.message || 'Failed to fetch employee details',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };
const token = localStorage.getItem('token'); 
        if (!token) {
          alert("No authentication token found. Please log in.");
          return;
        }
        const payload = JSON.parse(atob(token.split('.')[1]));
        const company_id = payload.company_id;
  // Handle tax form submission
const handleSubmit = async (e) => {
  e.preventDefault();
   if (!validateForm()) {
    setNotification({
      open: true,
      message: 'Please fill all required fields correctly',
      type: 'error'
    });
    return;
  }
  if (!employeeData || !financialYearFrom || !financialYearTo) {
    setNotification({
      open: true,
      message: 'Please fill all required fields',
      type: 'error'
    });
    return;
  }

  if (!isValidPAN(employerPan)) {
    setNotification({
      open: true,
      message: 'Please enter a valid Employer PAN (ABCDE1234F)',
      type: 'error'
    });
    return;
  }

  setSubmitting(true);
  try {
    // For Financial Year: April 2024 to March 2025
    const fromYear = financialYearFrom.getFullYear();
    const fromMonth = financialYearFrom.getMonth(); // JavaScript: 0=Jan, 3=Apr
    
    const toYear = financialYearTo.getFullYear();
    const toMonth = financialYearTo.getMonth(); // JavaScript: 0=Jan, 2=Mar

    // Create proper dates for financial year
    // FY From: April 1st of selected year
    const financial_year_from = `${fromYear}-${String(fromMonth + 1).padStart(2, '0')}-01`;
    
    // FY To: March 31st of selected year  
    const lastDayOfMarch = new Date(toYear, toMonth + 1, 0).getDate(); // Get last day of March
    const financial_year_to = `${toYear}-${String(toMonth + 1).padStart(2, '0')}-${String(lastDayOfMarch).padStart(2, '0')}`;


    const payload = {
      employee_id: employeeId,
      employer_name: employerName,
      employer_address: employerAddress,
      employer_pan: employerPan,
      cit: cit,
      assessment_year: assessmentYear,
      financial_year_from: financial_year_from,
      financial_year_to: financial_year_to,
    };

    const response = await axios.post(`${API_URL}/api/form16A/create`, payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    
    setNotification({
      open: true,
      message: 'Tax form submitted successfully',
      type: 'success'
    });
    
    const certificateNo = response.data?.data?.certifiacte_no || 
      response.data?.data?.certificate_no ||
      response.data?.certifiacte_no || 
      response.data?.certificate_no ||
      '';

    navigate('/form16-partB', { 
      state: { 
        employeeId: employeeId, 
        certificateNo: certificateNo,
      } 
    });

    // Reset form
    setEmployeeData(null);
    setEmployeeId('');
    setFinancialYearFrom(null);
    setFinancialYearTo(null);
    setAssessmentYear('');
    setEmployerPan('');
    setEmployerName('');
    setEmployerAddress('');
    setcit('');
    
  } catch (error) {
    //console.error('Error creating tax form:', error);
    setNotification({
      open: true,
      message: error.response?.data?.message || 'Failed to create tax form',
      type: 'error'
    });
  } finally {
    setSubmitting(false);
  }
};
  const isValidPAN = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(pan);


  // Close notification
  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  // Update assessment year when financial year changes
  const updateAssessmentYear = (date) => {
    if (date) {
      const toYear = date.getFullYear();
      setFinancialYearTo(date);
      setAssessmentYear(`${toYear}-${toYear + 1}`);
    }
  };

  const validateForm = () => {
  const errors = {
    employeeId: !employeeId,
    financialYearFrom: !financialYearFrom,
    financialYearTo: !financialYearTo,
    assessmentYear: !assessmentYear,
    employerName: !employerName.trim(),
    employerAddress: !employerAddress.trim(),
    employerPan: !employerPan.trim() || !isValidPAN(employerPan),
    cit: !cit.trim()
  };
  setValidationErrors(errors);
  return !Object.values(errors).some(error => error);
};

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Container fullWidth sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Tax Form Creation
        </Typography>

        {/* Button to reopen dialog when needed */}
        {!dialogOpen && (
          <Box display="flex" justifyContent="left" mt={3}>
            <Button variant="contained" color="primary" onClick={openEmployeeDialog}>
              Select Employee
            </Button>
          </Box>
        )} 

        {/* Employee Search Dialog */}
        <Dialog open={dialogOpen} onClose={closeEmployeeDialog} maxWidth="md"
  fullWidth 
  PaperProps={{           
    sx: {             
      height: '35vh',
      width: '800px',
      maxWidth: '90vw',
      margin: 'auto',
      marginLeft: '150px', // Adjust this value based on your sidebar width
    }         
  }}
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    '& .MuiDialog-container': {
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: '150px', // Same as sidebar width to offset centering
    }
  }} >
          <DialogTitle>
            Enter Employee ID
            <IconButton 
              onClick={closeEmployeeDialog} 
              sx={{ position: "absolute", right: 10, top: 10 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Employee ID"
              fullWidth
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
            />
            <Box display="flex" justifyContent="center" mt={3} gap={2}>
              <Button 
                onClick={fetchEmployeeDetails} 
                disabled={!employeeId || loading}
                variant="contained"
                color="primary"
              >
                {loading ? <CircularProgress size={24} /> : 'Search'}
              </Button>
              <Button variant="outlined" color="secondary" onClick={closeEmployeeDialog}>
                Cancel
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Main Form */}
        {employeeData && (
          <Paper elevation={3} sx={{ p: 3, mt: 3, borderRadius: 2, // Rounded corners
            border: '2px solid',
            borderColor: 'grey.300', // Subtle professional border
            boxShadow: 4, }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {/* Employee & Company Details */}
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Employee Information
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Employee ID"
                    value={employeeId}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Employee Name"
                    value={employeeData.employee.name || 'N/A'}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                
                
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Employee PAN"
                    value={employeeData.employee.panNumber || 'N/A'}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Employee Address"
                    value={employeeData.employee.address || 'N/A'}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Employer Information
                  </Typography>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Company Name"
                    value={employeeData.company.name || 'N/A'}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    required
                    label="Company TAN"
                    value={employeeData.company.tan||"N/A"}
                    InputProps={{ readOnly: true }}
                    onChange={(e) => setEmployerPan(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                <TextField
  fullWidth
  label="Employer Name *"
  value={employerName}
  onChange={(e) => {
    setEmployerName(e.target.value);
    setValidationErrors({...validationErrors, employerName: !e.target.value.trim()});
  }}
  // required
  error={validationErrors.employerName}
  helperText={validationErrors.employerName ? "Employer name is required" : ""}
/>
                </Grid>
                <Grid item xs={12} sm={6}>
                 <TextField
  fullWidth
  label="Employer Address *"
  value={employerAddress}
  onChange={(e) => {
    setEmployerAddress(e.target.value);
    setValidationErrors({...validationErrors, employerAddress: !e.target.value.trim()});
  }}
  // required
  error={validationErrors.employerAddress}
  helperText={validationErrors.employerAddress ? "Employer address is required" : ""}
/>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Employer Pan *"
                    value={employerPan}
                    onChange={(e) => {
      setEmployerPan(e.target.value);
      setEmployerPanError(!isValidPAN(e.target.value));
    }}
    // required
    error={employerPan !== '' && employerPanError}
    helperText={
      employerPan !== '' && employerPanError
        ? "Invalid PAN format (e.g., ABCDE1234F)"
        : "5 letters, 4 digits, 1 letter"
    }
    inputProps={{ maxLength: 10 }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Tooltip title="Tax office where your employer files TDS" placement='top'arrow>
                 <TextField
  fullWidth
  label="CIT(Commissioner of Income Tax) *"
  value={cit}
  onChange={(e) => {
    setcit(e.target.value);
    setValidationErrors({...validationErrors, cit: !e.target.value.trim()});
  }}
  // required
  error={validationErrors.cit}
  helperText={validationErrors.cit ? "CIT is required" : ""}
/>
                  </Tooltip>
                </Grid>
                
                

                {/* Financial Year Selection */}
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Financial Year Details
                  </Typography>
                </Grid>
                
                <Grid item xs={12} sm={4}>
                <Tooltip title="Financial year begins in April. Select April and the starting year" placement='top' arrow>
                <Box>
                  
                  <DatePicker
                    label="Financial Year From"
                    value={financialYearFrom}
                    onChange={(newValue) => setFinancialYearFrom(newValue)}
                    renderInput={(params) => (

                      <TextField {...params} fullWidth required />
                    )}
                    views={['year', 'month']}
                  />
                  </Box>
                  </Tooltip>
                </Grid>
                
                <Grid item xs={12} sm={4}>
                <Tooltip title="Financial year end in March. Select March and the ending year" placement='top' arrow>
                  <Box>
                <DatePicker
                    label="Financial Year To"
                    value={financialYearTo}
                    onChange={updateAssessmentYear}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth required />
                    )}
                    views={['year', 'month']}
                  />             
                       </Box>

                  </Tooltip>
                </Grid>
                
                <Grid item xs={12} sm={4}>
                  <Tooltip title="enter the Assessment year" placement='top' arrow>
                 <TextField
  fullWidth
  required
  label="Assessment Year"
  disabled
  value={assessmentYear}
  onChange={(e) => {
    setAssessmentYear(e.target.value);
    setValidationErrors({...validationErrors, assessmentYear: !e.target.value.trim()});
  }}
  error={validationErrors.assessmentYear}
  helperText={validationErrors.assessmentYear ? "Assessment year is required" : ""}
/>
                  </Tooltip>
                </Grid>

                {/* Submit Button */}
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    disabled={submitting}
                  >
                    {submitting ? <CircularProgress size={24} /> : 'Submit Tax Form'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        )}

        {/* Notification */}
        <Snackbar 
          open={notification.open} 
          autoHideDuration={5000} 
          onClose={handleCloseNotification}
        >
          <Alert 
            onClose={handleCloseNotification} 
            severity={notification.type} 
            sx={{ width: '100%' }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      </Container>
    </LocalizationProvider>
  );
};

export default SimpleTaxFormCreation;